import React, { useContext, useEffect } from 'react'

import { ReportingContext } from '../../wrappers/ReportingContext'
import { useFormContext } from 'react-hook-form'
import { useMemo, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { fetchingReportPreview } from '../../../utils/reporting/notifications'

const SaveButton = ({ isSubmitting }) => {
    return (
        <button 
            type="submit"
            className={`button is-link
                ${isSubmitting ? 'is-loading' : ''}
            `}
            disabled={isSubmitting}
        >
            Save
        </button>
    )
}

const ResetButton = ({ onClick, isSubmitting }) => {
    return (
        <button 
            type="button" 
            onClick={onClick}
            className="button"
            disabled={isSubmitting}
        >
            Reset
        </button>
    )
}


const ReturnLink = ({ to, text, onClick, className = "" }) => {
    return (
        <div className={`returnLinkHeaderWrapper ${className}`}>
            <ul><li>
                <div className="link"
                    onClick={onClick}
                >
                    <span className="icon">
                        <i className="fa fa-chevron-left" />
                    </span>
                    {text}
                </div>
            </li></ul>
        </div>
    )
}

const TopBar = () => {
    const { 
        resetForm, 
        isSubmitting, 
        setHasUnsavedChanges, 
        setReroute,
        selectedFormSection,
        previewReport,
    } = useContext(ReportingContext)
    const { watch, formState: { dirty }, triggerValidation } = useFormContext()
    const history = useHistory()
    const isPreviewTab = useMemo(() => selectedFormSection === 'Preview', [selectedFormSection])
    const isCreateReportTab = useMemo(() => selectedFormSection === 'Create Report', [selectedFormSection])
    
    const reportName = watch('reportName')
    const targetDatabase = watch('databaseName')
    const primaryDataSourceName = watch('primaryDataSourceName')

    const targetDatabaseDisplay = useMemo(() => targetDatabase && typeof targetDatabase === 'object' ? targetDatabase.label : targetDatabase, [targetDatabase])
    
    const primaryDataSourceNameDisplay = useMemo(() => primaryDataSourceName && typeof primaryDataSourceName === 'object' ? primaryDataSourceName.label : primaryDataSourceName, [primaryDataSourceName])

    useEffect(() => {
        if (isPreviewTab) {
            previewReport(watch({ nest: true }))
        }
    }, [isPreviewTab])

    return (
        <nav className="level">
            <ReturnLink 
                text="Return to Report List" 
                className="mb-4" 
                onClick={() => {
                    if (dirty) { // if form dirty thendisplay unsaved changes modal 
                        setReroute('/admin/reports')
                        setHasUnsavedChanges(true)
                    } else { //else just reroute
                        history.push(`/admin/reports`)
                    }
                }}
            />
            <div className='is-flex formReportInfo'>
                {targetDatabaseDisplay && (
                        <div className="reportInfoItem topbar-item-nowrap">
                            <p>
                                <strong>Database:</strong> {targetDatabaseDisplay}
                            </p>
                        </div>
                )}
                {primaryDataSourceNameDisplay && (
                        <div className="reportInfoItem topbar-item-nowrap">
                            <p>
                                <strong>Primary Source:</strong> {primaryDataSourceNameDisplay}
                            </p>
                        </div>
                )}
                {reportName && (
                        <div className="reportInfoItem topbar-item-nowrap">
                            <p>
                                <strong>Report Name:</strong> {reportName}
                            </p>
                        </div>
                )}
            </div>
            <div className="level-right" style={{ marginRight: 3, marginTop: '1vh' }}>
                    <div className="level-item">
                        <div className="buttons buttonWrapper">
                            {!isCreateReportTab && !isPreviewTab && (
                                <>
                                    <SaveButton isSubmitting={isSubmitting} />
                                    <ResetButton onClick={() => resetForm(true)} isSubmitting={isSubmitting} />
                                </>
                            )}
                        </div>
                    </div>
            </div>
        </nav>
    )
}

export default TopBar
